/* eslint-disable no-restricted-imports */

import React, { useContext } from "react";
import {
  Values,
  Components,
  Context as MFContext,
  FormattedMessage,
} from "@oursky/react-messageformat";
import { getName } from "@ntpu/i18n-iso-countries";
import { MessageID, Locale } from "./types";
import { LocalizationContext } from "./i18n";

export interface I18n {
  locale: Locale;
  translate: (id: MessageID, values?: Values) => string;
  setLocale: (locale: Locale) => void;
}

interface LocalisedTextProps {
  id: MessageID;
  values?: Values;
  components?: Components;
}

export const LocalisedText: React.FC<LocalisedTextProps> = props => {
  return <FormattedMessage {...props} />;
};

export function useI18n(): I18n {
  const context = useContext(MFContext);
  const localizationContext = useContext(LocalizationContext);
  return React.useMemo(() => {
    return {
      locale: context.locale as Locale,
      setLocale: localizationContext.setLocale,
      translate: context.renderToString,
    };
  }, [context, localizationContext]);
}

export function getCountryName(code: string, locale: string): string {
  // override library output here
  return getName(code, locale) || "";
}
